import generalSection from "../_section/section.class";
import ApplicationForm from "./ApplicationForm";
import DataForm from "./DataForm";
import {adminBerCertificateUpload, userBerCertificateUpload} from "./upload";
import problem from "../_section/section-problem.class";

export class userBerCertificateSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userBerCertificateUpload);
        // Add missing date error

    }
}
export class adminBerCertificateSection extends userBerCertificateSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminBerCertificateUpload);
        if (mortgage.activeSubmission?.lenderCode === "boi"){
            this.ApplicationForm = ApplicationForm
        }

        this.DataForm = DataForm
        this.sortByDateProp(null);
         this.activeUpload = this.uploads.find(u => u && u.isActive)
         this.setProblems( this.getProblems())
    }
     getProblems (){
         let problems = this.problemsList.universalUploadProblems();
         if (!problems?.length){
             problems = []
         }
         if (!problems.length){
             // just check application data is there
             const {property} = this.mortgage;
             const {berDiscussed, berReference, berExpiryDate, berEmissions, berKwhPerM2, berDateOfIssue  } = property
             if (!berDiscussed || !berReference || !berExpiryDate || !berEmissions || !berKwhPerM2 || !berDateOfIssue){
                 problems.push( new problem( {
                     type: 'BUNDLE',
                     title: 'BER Data Missing',
                     reason: 'Application data is missing BER information',
                     message: `The application is missing BER information`,
                 }))
             }
         }
         return problems||[];
    }

}